<div class="col-md-6 offset-md-3 mt-5">
    <div class="card">
        <div class="card-header d-flex flex-row">
            <div class="font-italic px-2 font-weight-bold" [ngSwitch]='env'>               
                <div *ngSwitchCase="'PROD'" style="color:goldenrod;"><i class="fa fa-certificate"></i> Production</div>
                <div *ngSwitchCase="'DEV'" style="color:blue;"><i class="fa fa-hammer"></i> Development</div>
                <div *ngSwitchCase="'STAGE'" style="color:blueviolet;"><i class="fa fa-screwdriver"></i> Staging</div>
                <div *ngSwitchCase="'INTERNAL'" style="color:magenta;">Internal</div>
                <div *ngSwitchCase="'DISH'"><i class="fa fa-satellite-dish" style="color:#DD1830;"></i> Dish Network</div>
                <div *ngSwitchCase="'APPLE'" style="color:gray;"><i class="fab fa-apple"></i> Apple</div>
                <div *ngSwitchDefault class="font-weight-bold">
                    {{env}}
                </div>
            </div>
            <div>
                Testbed Login
            </div>
        </div>
        <div class="card-body">            
            <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
                <div class="form-group">
                    <label for="username">Username</label>
                    <input type="text" #username formControlName="username" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.username.errors }" />
                    <div *ngIf="submitted && f.username.errors" class="invalid-feedback">
                        <div *ngIf="f.username.errors.required">Username is required</div>
                    </div>
                </div>
                <div class="form-group">
                    <label for="password">Password</label>
                    <input type="password" #password formControlName="password" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.password.errors }" />
                    <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
                        <div *ngIf="f.password.errors.required">Password is required</div>
                    </div>
                </div>
                <button [disabled]="loading" class="btn btn-primary">
                    <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
                    <span *ngIf="env=='PROD'">Production</span>
                    <span *ngIf="env=='DEV'">Development</span>
                    <span *ngIf="env=='STAGE'">Staging</span>
                    Login
                </button>
                <div *ngIf="error" class="alert alert-danger mt-3 mb-0">{{error}}</div>
            </form>
        </div>
    </div>
</div>